import React, { useEffect, useState } from "react";
// import "./Style.css";
import axios from "axios";
import { toast } from "react-toastify";
import {
  APIUrlOne,
  APIUrlThree,
  APIUrlToken,
  GetUserId,
} from "../../Utils/Utils";
import Layout from "../../Components/Layout/Layout";
import AiLeadsAction from "../../Components/AiLeads/AiLeadsButton/AiLeadsAction";
import Loader from "../../Components/Loader/Loader";
import Organizations from "../../Components/Favorites/FavoritesOrganization/Organizations";
import Prospects from "../../Components/Favorites/FavoritesProspects/Prospects";
import ProspectRequestModal from "../../Components/RequestUpdateModals/ProspectRequestModal";
import LeadsProspectModal from "../../Components/RequestUpdateModals/LeadsProspectModal";
import * as XLSX from "xlsx";

const Favorites = () => {
  const [archiveRecord, setArchiveRecord] = React.useState(false);
  const [trackRecord, setTrackRecord] = React.useState(false);
  const [requestUpdateRecord, setRequestUpdateRecord] = useState(false);
  const [disableRequestUpdate, setDisableRequestUpdate] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [isDecisionMakerExcel, setIsDecisionMakerExcel] = useState(false);
  const [isSalesForceTrigger, setIsSalesForceTrigger] = useState(false);
  const [selectedLeadsModal, setSelectedLeadsModal] = useState(false);
  const [selectedProspectsModal, setSelectedProspectsModal] = useState(false);
  const [showSalesForce, setShowSalesForce] = useState(false);
  const [showLeadsProspects, setShowLeadsProspects] = useState("");
  const [selectedProspectsInner, setSelectedProspectsInner] = React.useState(
    []
  );
  // for organization tracking
  const [trackingData, setTrackingData] = useState([]);
  const [disableTracking, setDisableTracking] = useState(false);
  const [selectedLeads, setSelectedLeads] = useState([]);

  // for prospects tracking
  const [selectedProspects, setSelectedProspects] = useState([]);

  const exportToExcel = (data, filename) => {
    const filteredData = data.map(
      ({ person_id, org_id, strengthData, ...rest }) => rest
    );
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
    setIsDecisionMakerExcel(false);
  };
  React.useEffect(() => {
    if (isDecisionMakerExcel) {
      if (selectedLeads?.length && selectedProspects?.length) {
        exportToExcel(selectedLeads, "leads_exported_data");
        exportToExcel(selectedProspects, "decisionmaker_exported_data");
      } else if (selectedLeads?.length && !selectedProspects?.length) {
        exportToExcel(selectedLeads, "leads_exported_data");
      } else if (!selectedLeads?.length && selectedProspects?.length) {
        exportToExcel(selectedProspects, "decisionmaker_exported_data");
      } else {
        toast.error("Please select records to download excel.");
      }
    }
    setIsDecisionMakerExcel(false);
  }, [isDecisionMakerExcel]);

  useEffect(() => {
    if (selectedProspects?.length) {
      setShowLeadsProspects("pros");
    } else if (selectedLeads?.length || selectedProspectsInner?.length) {
      setShowLeadsProspects("leads");
    } else {
      setShowLeadsProspects("");
    }
  }, [selectedLeads, selectedProspects, selectedProspectsInner]);

  useEffect(() => {
    if (archiveRecord === true) {
      if (!selectedLeads?.length && !selectedProspects?.length) {
        toast.error("Please select record to archive.");
      }
    }
    setArchiveRecord(false);
  }, [archiveRecord]);

  useEffect(() => {
    if (
      selectedLeads?.length + selectedProspects?.length < 1 &&
      requestUpdateRecord == true
    ) {
      setDisableRequestUpdate(false);
      setRequestUpdateRecord(false);
      toast.error("Please select record to request update");
      return;
    } else if (
      selectedLeads?.length + selectedProspects?.length === 1 &&
      requestUpdateRecord == true
    ) {
      if (selectedLeads?.length === 1) {
        setSelectedLeadsModal(true);
      } else {
        setSelectedProspectsModal(true);
      }
      setRequestUpdateRecord(false);
      setDisableRequestUpdate(false);
    } else if (selectedLeads?.length + selectedProspects?.length > 1) {
      setDisableRequestUpdate(true);
      setRequestUpdateRecord(false);
    } else {
      setDisableRequestUpdate(false);
    }
  }, [selectedLeads, selectedProspects, requestUpdateRecord]);

  const handleTrackingdata = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_tracking?user_id=${Number(GetUserId())}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = e?.data?.data;
        setTrackingData(data);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    handleTrackingdata();
  }, []);

  useEffect(() => {
    if (trackingData.length > 0 && selectedLeads.length > 0) {
      const isMatching = trackingData.some((trackingItem) =>
        selectedLeads.every(
          (selectedItem) =>
            Number(selectedItem.org_id) === Number(trackingItem.org_id)
        )
      );

      setDisableTracking(isMatching);
    } else {
      setDisableTracking(false);
    }
  }, [trackingData, selectedLeads]);

  useEffect(() => {
    if (trackingData.length > 0 && selectedProspects.length > 0) {
      const isMatching = trackingData.some((trackingItem) =>
        selectedProspects.every(
          (selectedItem) =>
            Number(selectedItem.person_id) === Number(trackingItem.person_id)
        )
      );

      setDisableTracking(isMatching);
    } else {
      setDisableTracking(false);
    }
  }, [trackingData, selectedProspects]);

  return (
    <>
      <Layout>
        {loading ? <Loader /> : null}
        <div className="child-section-of-everypage  ">
          <div style={{ display: "flex" }}>
            <div>
              <AiLeadsAction
                disableTracking={disableTracking}
                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                setIsSalesForceTrigger={setIsSalesForceTrigger}
                isSalesForceTrigger={isSalesForceTrigger}
                archiveRecord={archiveRecord}
                setArchiveRecord={setArchiveRecord}
                setTrackRecord={setTrackRecord}
                disableRequestUpdate={disableRequestUpdate}
                setRequestUpdateRecord={setRequestUpdateRecord}
                showSalesForce={showSalesForce}
              />
            </div>
          </div>

          {/* Favorites Organization table  */}
          <div
            style={{
              display: "flex",
              zIndex: "999",
              padding: "50px 0px 10px 0px",
            }}
          >
            {" "}
            <p style={{ fontSize: "16px", fontWeight: "700" }}>Organizations</p>
          </div>
          <Organizations
            handleTrackingdata={handleTrackingdata}
            trackingData={trackingData}
            setLoading={setLoading}
            isSalesForceTrigger={isSalesForceTrigger}
            setIsSalesForceTrigger={setIsSalesForceTrigger}
            isDecisionMakerExcel={isDecisionMakerExcel}
            setIsDecisionMakerExcel={setIsDecisionMakerExcel}
            archiveRecord={archiveRecord}
            setArchiveRecord={setArchiveRecord}
            trackRecord={trackRecord}
            setTrackRecord={setTrackRecord}
            selectedOuterRows={selectedLeads}
            setSelectedOuterRows={setSelectedLeads}
            setShowSalesForce={setShowSalesForce}
            showLeadsProspects={showLeadsProspects}
            selectedRows={selectedProspectsInner}
            setSelectedRows={setSelectedProspectsInner}
          />
          {/* Favorites Prospects table  */}
          <div
            style={{
              display: "flex",
              zIndex: "999",
              padding: "20px 0px 10px 0px",
            }}
          >
            {" "}
            <p style={{ fontSize: "16px", fontWeight: "700" }}>Prospects</p>
          </div>
          <Prospects
            handleTrackingdata={handleTrackingdata}
            trackingData={trackingData}
            setIsSalesForceTrigger={setIsSalesForceTrigger}
            isSalesForceTrigger={isSalesForceTrigger}
            setLoading={setLoading}
            isDecisionMakerExcel={isDecisionMakerExcel}
            setIsDecisionMakerExcel={setIsDecisionMakerExcel}
            archiveRecord={archiveRecord}
            setArchiveRecord={setArchiveRecord}
            trackRecord={trackRecord}
            setTrackRecord={setTrackRecord}
            selectedOuterRows={selectedProspects}
            setSelectedOuterRows={setSelectedProspects}
            setShowSalesForce={setShowSalesForce}
            showLeadsProspects={showLeadsProspects}
          />
        </div>
      </Layout>
      <ProspectRequestModal
        requestUpdateRecord={selectedProspectsModal}
        setRequestUpdateRecord={setSelectedProspectsModal}
        profileData={selectedProspects[0]}
        peopleId={selectedProspects?.[0]?.leads_id}
      />

      <LeadsProspectModal
        requestUpdateRecord={selectedLeadsModal}
        setRequestUpdateRecord={setSelectedLeadsModal}
        profileData={selectedLeads[0]}
        peopleId={selectedLeads?.[0]?.org_id}
      />
    </>
  );
};
export default Favorites;
